import { useSearchParams } from 'react-router-dom';
import { DetailsDrawer } from '../../Compounds/DetailsDrawer/DetailsDrawer';
import { getMetaData } from '../../Compounds/DetailsDrawer/detailsDrawersHelpers';
import type { LocationGridRow } from './locationsGridColumnDefs';

export const LOCATION_KEY_PARAM = 'locationKey';

export type LocationDrawerProps = {
  locations: LocationGridRow[];
};

export function LocationDrawer({ locations }: LocationDrawerProps) {
  const [params] = useSearchParams();
  const locationKey = params.get(LOCATION_KEY_PARAM);
  const location = locationKey ? locations.find((row) => row.location_key === locationKey) : undefined;

  return (
    <DetailsDrawer
      {...getMetaData('location')}
      data={location}
      showDrawer={!!location}
      paramKey={LOCATION_KEY_PARAM}
    />
  );
}
